<template>
  <app-section theme="nude" class="v2-agb">
    <div class="row">
      <div class="col-12 col-lg-8 order-2 order-lg-0">
        <imprint />
      </div>
      <div class="col-12 col-lg-4">
        <template v-if="locale !== 'de'">
          <template v-if="!companyStore.isEFC">
            <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb">
              {{ t("IMPRINT") }}
            </router-link>
            <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb#legal">
              {{ t("2257 NOTICE / LEGAL") }}
            </router-link>
          </template>
          <router-link v-else class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="agb#legal">
            {{ t("LEGAL") }}
          </router-link>

          <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb#privacy_policy">
            {{ t("PRIVACY POLICY") }}
          </router-link>

          <router-link v-if="companyStore.isEFC" class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb#notice">
            {{ t("2257 NOTICE") }}
          </router-link>

          <a
            v-if="locale === 'en'"
            class="btn btn-outline-dark me-lg-3 mb-2 d-block"
            href="https://www.rabbitsreviews.com/Default.aspx"
            rel="nofollow"
          >
            {{ t("Rabbits Porn Reviews") }}
          </a>
        </template>
        <template v-else>
          <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb">
            {{ t("IMPRINT") }}
          </router-link>
          <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/agb#legal">
            {{ t("2257 NOTICE / LEGAL") }}
          </router-link>
          <router-link class="btn btn-outline-dark me-lg-3 mb-2 d-block" to="/privacy_policy">
            {{ t("PRIVACY POLICY") }}
          </router-link>
        </template>
      </div>
    </div>
    <terms-and-conditions />
  </app-section>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useCompanyStore } from "@/store/company";
import TermsAndConditions from "@/components/terms-and-conditions/index.vue";
import AppSection from "@/components/v2/section/index.vue";
import Imprint from "@/components/imprint/index.vue";

defineOptions({
  name: "agb-v2",
});

const companyStore = useCompanyStore();
const { locale, t } = useI18n();
</script>

<style lang="scss">
@import "./index";
</style>
